import React from 'react';
import { Typography } from 'seagull';
import styles from "./CreateAVendorAccountPrompt.module.scss";
import { CreateAVendorAccount } from "../../../components/NavigationAndStructure/TopBar/components/CreateAVendorAccount";
import { useStoreActions } from "../../../contexts";
export default function CreateAVendorAccountPrompt() {
  const {
    logBI
  } = useStoreActions();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.createVendorServiceTextBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    weight: "bold",
    className: styles.createVendorPromptText
  }, "Simplify proposal signing and billing for your business, too."), /*#__PURE__*/React.createElement(CreateAVendorAccount, {
    variant: 'text',
    onClick: () => logBI(18105)
  }));
}